import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';

export const BillingDetailsModalContainer = styled(Column)`
  flex-shrink: 1;
  box-sizing: border-box;
  width: 620px;
  max-width: 620px;
  background-color: ${({ theme }): string => theme.colors.bodyBg};
`;

export const ModalContent = styled(Column)`
  flex: 1;
  padding: 20px;
`;

export const FooterRow = styled(Row)`
  justify-content: flex-end;
  padding-bottom: 20px;
  padding-right: 20px;
`;

export const ButtonContainer = styled(Row)`
  width: 205px;
`;

export const WhiteModalHeader = styled(Row)`
  align-items: center;
  height: 76px;
  padding: 0 20px;
  background-color: ${({ theme }): string => theme.colors.white};

  svg {
    margin-right: 10px;
  }
`;
